import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.631 8.39v-.074a6.316 6.316 0 10-6.24 6.315 7.373 7.373 0 016.24-6.24zM10.84 4.08v.864h-.888V10H8.92V7.704l-.936-.008c.016.101.024.2.024.296 0 .47-.15.845-.448 1.128-.299.283-.696.424-1.192.424a2.17 2.17 0 01-.968-.208 1.565 1.565 0 01-.648-.584 1.653 1.653 0 01-.232-.872h.968c0 .224.075.41.224.56.15.144.344.216.584.216s.43-.07.568-.208a.763.763 0 00.208-.552.75.75 0 00-.224-.552c-.15-.155-.37-.232-.664-.232H5.84V6.28h.344c.256 0 .456-.067.6-.2A.64.64 0 007 5.592a.663.663 0 00-.208-.512.683.683 0 00-.504-.2c-.219 0-.4.064-.544.192a.633.633 0 00-.216.496h-.952c0-.31.072-.581.216-.816a1.43 1.43 0 01.6-.552c.261-.128.56-.192.896-.192.49 0 .885.13 1.184.392.299.261.448.61.448 1.048 0 .293-.077.55-.232.768a1.215 1.215 0 01-.656.448v.016c.139.027.272.083.4.168H8.92V4.08h1.92zM15.5 21a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0 1a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm-.956-5.472l-.368 1.064H13L15.008 12h1.304l2.008 5.592h-1.184l-.368-1.064h-2.224zm1.92-.896l-.808-2.336-.808 2.336h1.616z"
        fill="#000"
        fillOpacity={0.8}
      />
    </Svg>
  );
}

export default SvgComponent;
